import { Injectable } from "@angular/core";
import { SelectBox } from 'cbc-shared-lib';

@Injectable({
    providedIn: 'root'
})

export class ListSearchUtils {

    /**
     * ドロップダウンリストの初期選択値取得
     *
     * @param {string} value 返ってきた初期値
     * @param {SelectBox[]} list ドロップダウンリストの選択肢リスト
     * @memberof ListSearchUtils
     */
    public getListboxValue(value: string, list: SelectBox[]) {
        var selected = list.find(e => e.value === value);
        return selected?.value;
    }

    /**
     * ドロップダウンリストの初期選択値取得(引数がstring配列)
     *
     * @param {string} value 返ってきた初期値
     * @param {SelectBox[]} list ドロップダウンリストの選択肢リスト
     * @memberof ListSearchUtils
     */
    public getStringListValue(value: string, list: Array<string>) {
        var selected = list.find(e => e === value);
        return selected;
    }
}
